/* eslint-disable prefer-rest-params */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
import React, { useEffect } from 'react';

import { QueryClient, QueryClientProvider } from 'react-query';
import { unstable_HistoryRouter as HistoryRouter, Navigate, Route, Routes } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import { SocketContext, socket } from '../context';
import UiContextProvider from '../context/UiContext';
import UIHelperProvider from '../context/UIHelperContext';
import { UIHelperPortal } from '../components/UIHelper';

import PrivateRoute from '../containers/PrivateRoute';
import { TRIAL_SIGNUP_ENABLED } from '../constants/main';
import SignUpPage from '../pages/SignUpPage';
import SignInPage from '../pages/SignInPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import ProfilePage from '../pages/ProfilePage';
import MeetingsPage from '../pages/MeetingsPage';
import MeetingPage from '../pages/MeetingPage';
import MeetingPageNew from '../pages/MeetingPageNew';
import SharedMeetingPage from '../pages/SharedMeetingPage';
import ChangePasswordPage from '../pages/ChangePasswordPage';
import LibraryPage from '../pages/LibraryPage';
import RequestFolderAccessPage from '../pages/RequestFolderAccessPage';
import ViewerReportPage from '../pages/ViewerReportPage';
import SummaryReportPage from '../pages/SummaryReportPage';
import TrashBinPage from '../pages/TrashBinPage';
import CreateVideoNewPage from '../pages/CreateVideoNewPage';
import CreateVideoRouter from '../pages/CreateVideoRouter';
import OrganizationSettingsPage from '../pages/OrganizationSettingsPage';
import SuperAdminPage from '../pages/SuperAdminPage';
import SuperAdminHelpCenterPage from '../pages/SuperAdminHelpCenterPage';
import PricingPage from '../pages/PricingPage';
import SuperAdminTiersPage from '../pages/SuperAdminTiersPage';
import OrganizationDetailPage from '../pages/OrganizationDetailPage';
import OrganizationEditPage from '../pages/OrganizationEditPage';
import OrganizationNewPage from '../pages/OrganizationNewPage';
import OnboardingPage from '../pages/OnboardingPage';
import TrainingPathsPage from '../pages/TrainingPathsPage';
import CreateTrainingPathPage from '../pages/CreateTrainingPathPage';
import TrainingPathTraineesPage from '../pages/TrainingPathTraineesPage';
import TrainingPathDetailPage from '../pages/TrainingPathDetailPage';
import TemplatesPage from '../pages/TemplatesPage';
import { useUiStore } from '../store';
// Training paths routes are now always available - components handle org-level feature checking

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const history = createBrowserHistory();

const RoutesComponent = () => {
  const isSidebarCollapsed = useUiStore((state) => state.isSidebarCollapsed);

  /*   const [redirectAfterLogin, setRedirectAfterLogin] = useState('');

  const notifyError = useCallback(
    (message, options) => toast.error(message, options),
    []
  );
  const notifySuccess = useCallback(
    (message, options) => toast.success(message, options),
    []
  ); */

  useEffect(() => {
    if (isSidebarCollapsed) {
      document.documentElement.style.setProperty('--sidebar-width', '126px');
    } else {
      document.documentElement.style.setProperty('--sidebar-width', '373px');
    }
  }, [isSidebarCollapsed]);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: 460388, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }, []);

  return (
    <HistoryRouter history={history}>
      <QueryClientProvider client={queryClient}>
        <UIHelperProvider>
        <UiContextProvider>
          <SocketContext.Provider value={{ socket }}>
            <UIHelperPortal />
            <Routes>
              <Route path="/" element={<Navigate to="/my-videos" replace />} />
              <Route
                path="/sign-up"
                element={
                  TRIAL_SIGNUP_ENABLED ? (
                    <SignUpPage />
                  ) : (
                    <Navigate to="/sign-in" replace />
                  )
                }
              />
              <Route path="/sign-in" element={<SignInPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/change-password" element={<ChangePasswordPage />} />
              <Route
                path="/onboarding"
                element={
                  <PrivateRoute>
                    <OnboardingPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pricing"
                element={
                  <PrivateRoute>
                    <PricingPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <ProfilePage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/create-video-new"
                element={
                  <PrivateRoute>
                    <CreateVideoNewPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/my-videos-new/:id/edit"
                element={
                  <PrivateRoute>
                    <CreateVideoNewPage />
                  </PrivateRoute>
                }
              />
              <Route path="/my-videos-new/:id" element={<MeetingPageNew />} />
              <Route
                path="/create-video"
                element={
                  <PrivateRoute>
                    <CreateVideoRouter />
                  </PrivateRoute>
                }
              />
              <Route
                path="/my-videos"
                element={
                  <PrivateRoute>
                    <MeetingsPage />
                  </PrivateRoute>
                }
              />
              <Route path="/my-videos/:id" element={<MeetingPageNew />} />
              <Route
                path="/my-videos/:id/history"
                element={
                  <PrivateRoute>
                    <MeetingsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/my-videos/:id/edit"
                element={
                  <PrivateRoute>
                    <CreateVideoRouter />
                  </PrivateRoute>
                }
              />
              <Route
                path="/my-videos/:id/preview"
                element={
                  <PrivateRoute>
                    <MeetingPage preview />
                  </PrivateRoute>
                }
              />
              <Route
                path="/my-library"
                element={
                  <PrivateRoute>
                    <LibraryPage key={3} />
                  </PrivateRoute>
                }
              />
              <Route
                path="/my-library/:id"
                element={
                  <PrivateRoute>
                    <LibraryPage key={4} />
                  </PrivateRoute>
                }
              />
              <Route
                path="/my-library/:id/edit"
                element={
                  <PrivateRoute>
                    <CreateVideoRouter />
                  </PrivateRoute>
                }
              />
              <Route
                path="/my-library/:id/viewer-report"
                element={
                  <PrivateRoute>
                    <ViewerReportPage withLayout />
                  </PrivateRoute>
                }
              />
              <Route
                path="/templates"
                element={
                  <PrivateRoute>
                    <TemplatesPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/templates/create"
                element={
                  <PrivateRoute>
                    <CreateVideoNewPage editorMode="template_creation" />
                  </PrivateRoute>
                }
              />
              <Route
                path="/templates/:id/edit"
                element={
                  <PrivateRoute>
                    <CreateVideoNewPage editorMode="template_creation" />
                  </PrivateRoute>
                }
              />
              <Route
                path="/trash-bin"
                element={
                  <PrivateRoute>
                    <TrashBinPage key={5} />
                  </PrivateRoute>
                }
              />
              <Route
                path="/trash-bin/:id"
                element={
                  <PrivateRoute>
                    <TrashBinPage key={6} />
                  </PrivateRoute>
                }
              />
              <Route path="/shared-video/:id" element={<SharedMeetingPage />} />
              <Route
                path="/request-folder-access/:id"
                element={
                  <PrivateRoute>
                    <RequestFolderAccessPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/viewer-report/:id"
                element={
                  <PrivateRoute>
                    <ViewerReportPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/summary-report"
                element={
                  <PrivateRoute>
                    <SummaryReportPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/training-paths"
                element={
                  <PrivateRoute>
                    <TrainingPathsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/training-paths/trainees"
                element={
                  <PrivateRoute>
                    <TrainingPathTraineesPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/create-training-path"
                element={
                  <PrivateRoute>
                    <CreateTrainingPathPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/training-paths/:id"
                element={
                  <PrivateRoute>
                    <TrainingPathDetailPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/training-paths/:id/edit"
                element={
                  <PrivateRoute>
                    <CreateTrainingPathPage />
                  </PrivateRoute>
                }
              />

              <Route
                path="/organization-settings"
                element={
                  <PrivateRoute>
                    <OrganizationSettingsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/organization-settings/*"
                element={
                  <PrivateRoute>
                    <OrganizationSettingsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/organization-settings/*"
                element={
                  <PrivateRoute>
                    <OrganizationSettingsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/super-admin"
                element={
                  <PrivateRoute>
                    <SuperAdminPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/super-admin/help-center"
                element={
                  <PrivateRoute>
                    <SuperAdminHelpCenterPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/super-admin/tiers"
                element={
                  <PrivateRoute>
                    <SuperAdminTiersPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/super-admin/organizations/new"
                element={
                  <PrivateRoute>
                    <OrganizationNewPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/super-admin/organizations/:id/edit"
                element={
                  <PrivateRoute>
                    <OrganizationEditPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/super-admin/organizations/:id"
                element={
                  <PrivateRoute>
                    <OrganizationDetailPage />
                  </PrivateRoute>
                }
              />
            </Routes>
          </SocketContext.Provider>
        </UiContextProvider>
        </UIHelperProvider>
      </QueryClientProvider>
    </HistoryRouter>
  );
};

export default RoutesComponent;
